import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNotificationsCountKey, getNotificationsKey, getReadNotificationKey, } from '../../utils/keys';
export const useReadNotification = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.notifications.readNotification(input), {
        onMutate: variables => {
            const notificationsKey = getNotificationsKey();
            queryClient.setQueriesData(notificationsKey, input => {
                const updatedInput = {
                    ...input,
                    pages: input.pages.map(page => ({
                        ...page,
                        nodes: page.nodes.map(notification => ({
                            ...notification,
                            read: notification.id === variables.notificationId
                                ? true
                                : notification.read,
                        })),
                        edges: page.edges.map(edge => ({
                            ...edge,
                            node: {
                                ...edge.node,
                                read: edge.node.id === variables.notificationId
                                    ? true
                                    : edge.node.read,
                            },
                        })),
                    })),
                };
                return updatedInput;
            });
        },
        onSettled: () => {
            const notificationsKey = getNotificationsKey();
            queryClient.invalidateQueries(notificationsKey);
            const notificationsCountKey = getNotificationsCountKey();
            queryClient.invalidateQueries(notificationsCountKey);
        },
        mutationKey: getReadNotificationKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useReadNotification.js.map